import * as types from '../actions/notifications/types';


const INITIAL_STATE = {
  firstBlock: {
    header: '',
    notifications: [],
  },
  secondBlock: {
    header: '',
    notifications: [],
  },
};

export default function notificationsReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.FETCH_FIRST_BLOCK_NOTIFICATIONS:
      return { ...state, firstBlock: action.payload };

    case types.FETCH_SECOND_BLOCK_NOTIFICATIONS:
      return { ...state, secondBlock: action.payload };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js